import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=32cf2a0e&scoped=true&"
import script from "./RoleTable.vue?vue&type=script&lang=js&"
export * from "./RoleTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleTable.vue?vue&type=style&index=0&id=32cf2a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf2a0e",
  null
  
)

export default component.exports